import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslationDirective } from '../../../shared/translation-directive';

@Component({
  selector: 'upu-not-found',
  imports: [TranslationDirective, MatButtonModule, RouterLink, MatIcon],
  host: {
    class: 'pt-20 flex flex-col items-center justify-center ',
  },
  templateUrl: './not-found.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFound {
  private readonly location = inject(Location);

  protected goBack(): void {
    this.location.back();
  }
}
